import { useScrollReveal } from '../hooks/useScrollReveal';

export default function WhyMiso() {
  const label = useScrollReveal(0);
  const heading = useScrollReveal(0.1);
  const body = useScrollReveal(0.2);

  return (
    <section
      id="why-miso"
      data-testid="why-miso-section"
      className="section-pad"
      style={{ backgroundColor: '#FDF6F4' }}
    >
      <div className="container-miso">
        <div style={{ maxWidth: '760px' }}>
          <span ref={label.ref} style={label.style} className="section-label">
            Our Story
          </span>

          <div className="airmail-stripe-sm" style={{ marginBottom: '28px' }} />

          <h2
            ref={heading.ref}
            style={{ ...heading.style, marginBottom: '28px' }}
            className="h2-miso"
          >
            We built MISO because every photo booth we&apos;d seen at weddings looked{' '}
            <span className="italic-accent" style={{ color: '#B85C3A' }}>the same.</span>
          </h2>

          <p
            ref={body.ref}
            style={{ ...body.style, maxWidth: '680px' }}
            className="body-miso"
          >
            A black box in the corner. Generic prints nobody kept. We thought: what if the booth itself was beautiful enough to be part of the decor? What if it printed postcards, not strips? What if it captured voices, not just faces? MISO is what happened.
          </p>

          <div style={{ marginTop: '36px' }}>
            <div
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: '16px',
                backgroundColor: 'rgba(246,188,202,0.2)',
                border: '1px solid rgba(232,160,178,0.3)',
                borderRadius: '8px',
                padding: '16px 24px',
              }}
            >
              <div
                style={{
                  width: '4px',
                  height: '48px',
                  background: 'linear-gradient(to bottom, #C44040, #FAF5EF, #3B5BA5)',
                  borderRadius: '2px',
                  flexShrink: 0,
                }}
              />
              <p
                style={{
                  fontFamily: 'Graphik, sans-serif',
                  fontWeight: 400,
                  fontStyle: 'italic',
                  fontSize: '14px',
                  color: '#6B5D50',
                  lineHeight: 1.6,
                  margin: 0,
                }}
              >
                The booth is the decoration. The print is the memory. The voice message is the gift.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
